import { images } from "../data/siteData";

function Hero() {
  return (
    <section id="top" className="hero">
      <div className="container hero__inner">
        <div className="hero__content">
          <p className="eyebrow">Curtains · Blinds · Fabrics · Tracks</p>
          <h1>Transforming Your Space from Ordinary to Extraordinary</h1>
          <p className="hero__subtext">
            From free in-home measuring to custom-made curtains and blinds, professionally
            installed — we will dress your windows how you imagined.
          </p>
          <div className="hero__actions">
            <a href="#contact" className="btn btn--primary">
              Get a Free Quote
            </a>
          </div>
        </div>
        <div className="hero__image">
          <img src={images.hero} alt="Sheer linen curtains drawn across a bright living room with a sofa and coffee table" loading="eager" />
        </div>
      </div>
    </section>
  );
}

export default Hero;
